import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import Member, { MemberState } from '@src/data/member'
import { Select } from '@src/elements/select/select'
import { Option } from '@src/elements/select/option'
import { OptionGroup } from '@src/elements/select/option-group'
import { MemberFilters } from '@src/state/store'

@Component({
  computed: {
    filters () {
      return this.$store.state.memberFilters
    }
  }
})
export class MemberStateFilter extends Vue {

  @Prop({ required: false })
  members: Member[]

  @Prop({ required: false })
  counters: any

  private filters: MemberFilters
  filterByState (value: string) {
    if (value === 'toBeDeactivated') {
      return this.$store.dispatch('filterMembers', { state: undefined, toBeDeactivated: true })
    }
    return this.$store.dispatch('filterMembers', { state: (value === 'all') ? undefined : value, toBeDeactivated: false })
  }

  getToBeDeactivatedCounter () {
    if (!this.counters) return 0
    return this.counters.toBeDeactivated || this.counters.withToBeDeactivated || 0
  }

  formatCounter (value: number | undefined | null): string {
    return `${value || 0}`
  }

  render (h: CreateElement) {
    let stateFilterLabel = this.$t(`PAGE.MEMBERS.FILTER.STATE.${{
      undefined: 'ALL',
      published: 'ACTIVE',
      deactivated: 'DEACTIVATED',
      intern: 'INTERN',
      toBeDeactivated: 'TO_BE_DEACTIVATED'
    }[this.filters.toBeDeactivated ? 'toBeDeactivated' : `${this.filters.state}`]}`)

    return <Select filter={true} class='state-filter-dropdown' value={stateFilterLabel} ref='stateFilter'>
      <OptionGroup>
        <Option type='single-option' value={'all'} label={this.$t('PAGE.MEMBERS.FILTER.STATE.ALL')}
                selected={this.filters.state === undefined} select={this.filterByState}
                detail={this.formatCounter(this.counters ? this.counters.total : 0)} />
        <Option type='single-option' value={'published'} label={this.$t('PAGE.MEMBERS.FILTER.STATE.ACTIVE')}
                selected={this.filters.state === 'published'} select={this.filterByState}
                detail={this.formatCounter(this.counters ? this.counters![MemberState.PUBLISHED] : 0)} />
        <Option type='single-option' value={'deactivated'} label={this.$t('PAGE.MEMBERS.FILTER.STATE.DEACTIVATED')}
                selected={this.filters.state === 'deactivated'} select={this.filterByState}
                detail={this.formatCounter(this.counters ? this.counters![MemberState.DEACTIVATED] : 0)} />
        <Option type='single-option' value={'toBeDeactivated'} label={this.$t('PAGE.MEMBERS.FILTER.STATE.TO_BE_DEACTIVATED')}
                selected={this.filters.toBeDeactivated === true} select={this.filterByState}
                detail={this.formatCounter(this.getToBeDeactivatedCounter())} />
        <Option type='single-option' value={'intern'} label={this.$t('PAGE.MEMBERS.FILTER.STATE.INTERN')}
                selected={this.filters.state === 'intern'} select={this.filterByState}
                detail={this.formatCounter(this.counters ? this.counters![MemberState.INTERN] : 0)} />
      </OptionGroup>
    </Select>
  }
}
